// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"4":"04208259","6":"abf76f2c","392":"1e567ead","419":"790547e5","472":"1a46771f","478":"91e0eb97","554":"7f520941","606":"f69795b4","640":"aa03801f","666":"72685bc5","751":"e73a7189","790":"1e1bb466","809":"4b5f5270","848":"5f075b21","884":"1efa91a0","964":"2c8d4f87"}[chunkId] + ".js";
};